export interface GroupInformationOptions {
  isGroupBooking: boolean
  groupName: string
  groupSize: number | null
}

export function formatGroupInformation(
  { isGroupBooking, groupName, groupSize }: GroupInformationOptions,
  formatGroupSize: (groupSize: number) => string,
): string | null {
  if (!isGroupBooking || (!groupName && groupSize === null)) {
    return null
  }

  const information = []

  if (groupName) {
    information.push(groupName)
  }

  if (groupSize !== null) {
    information.push(formatGroupSize(groupSize))
  }

  return information.join(' - ')
}
